<mat-drawer-container [hasBackdrop]="true">

  <mat-drawer [opened]="isOpenNotification()" mode="over" position="end" disableClose>
    <under-ui-notifications-panel></under-ui-notifications-panel>
  </mat-drawer>

  <mat-drawer-content>
    <div class="flex flex-col h-screen overflow-hidden">
      <under-ui-header
        [unreadNotificationsCount]="(unreadMessageCount$ | async) ?? 0"
        [isSidebarCollapsed]="isSidebarCollapsed()"
        (toggleNotificationSidebar)="onToggleNotificationSidebar()"
        (toggleSidebar)="onToggleSidebar()">
      </under-ui-header>

      <div class="flex flex-1 overflow-hidden border-t border-[var(--mat-app-outline-variant)]">
        <aside class="flex-shrink-0 overflow-y-auto overflow-x-hidden pt-4 border-r border-[var(--mat-app-outline-variant)] transition-[width] duration-[250ms] ease-in-out"
               [ngClass]="isSidebarCollapsed() ? 'w-[4.5rem]' : 'w-60'">
          <under-ui-navbar [buttons]="(navbarItems$ | async) ?? []" [collapsed]="isSidebarCollapsed()" (onExpandRequest)="isSidebarCollapsed.set(false)" />
        </aside>

        @let pageScrollLocked = pageScrollLock.lock$ | async;
        <main class="page-content flex-1 min-w-0 overflow-x-hidden py-4 px-4 lg:px-8 flex flex-col gap-1.5"
          [class.overflow-y-auto]="!pageScrollLocked"
          [class.overflow-y-hidden]="pageScrollLocked">
          @if ((passwordExpiresInDays$ | async); as daysRemaining) {
            @if (!isPasswordExpiryBannerDismissed()) {
              <under-ui-password-expiry-banner
                [daysRemaining]="daysRemaining"
                (dismissed)="isPasswordExpiryBannerDismissed.set(true)">
              </under-ui-password-expiry-banner>
            }
          }

          <div class="flex justify-between items-center gap-2 flex-wrap w-full min-w-0">
            @if (breadcrumbsItems$(); as breadcrumbItems) {
              <app-breadcrumbs [items]="breadcrumbItems" [state]="stateBreadcrumbs$()"></app-breadcrumbs>
            }

            @if (currentOrganization$ | async; as currentOrganization) {
              <button class="self-start rounded-[10px] px-2.5 py-0.5 bg-transparent font-['Manrope'] text-base text-[var(--mat-app-on-secondary-container)] border border-[var(--mat-app-on-secondary-container)] cursor-pointer hover:bg-[var(--mat-app-hover-background)]" [matMenuTriggerFor]="changeOrganization">
                {{ currentOrganization.name }}
              </button>

              <mat-menu class="cancel-menu" #changeOrganization="matMenu" xPosition="before">
                @for (organisation of organisation$ | async; track organisation.id) {
                  <button
                    mat-menu-item
                    class="active"
                    [disabled]="organisation.isActive"
                    (click)="changeOrganisation(organisation.id, organisation.isActive)">
                    <span>{{ organisation.name }}</span>
                  </button>
                }
              </mat-menu>
            }
          </div>
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>

    <!-- <under-ui-onboarding-overlay></under-ui-onboarding-overlay> -->

<!--    <under-ui-ai-chat-widget></under-ui-ai-chat-widget>-->
  </mat-drawer-content>
</mat-drawer-container>
